import { useTranslation } from 'react-i18next';
import { TEACHING_LEVELS } from '../../lib/teaching.js';

export default function TeachingFilters({ facets, filters, onChange, onClear, activeCount }) {
  const { t } = useTranslation();
  function update(patch) {
    onChange({ ...filters, ...patch });
  }
  return (
    <aside className="space-y-6">
      <header className="flex items-center justify-between">
        <h2 className="font-serif text-lg text-gold-light">{t('common.filter')}</h2>
        {activeCount > 0 && (
          <button
            type="button"
            onClick={onClear}
            className="text-xs font-medium text-gold-light hover:underline"
          >
            {t('bibliography.clearAll')} ({activeCount})
          </button>
        )}
      </header>

      <Group label={t('teaching.filter.level')}>
        <select
          value={filters.level}
          onChange={(e) => update({ level: e.target.value })}
          className="form-input"
        >
          <option value="">{t('teaching.filter.allLevels')}</option>
          {TEACHING_LEVELS.map((l) => {
            const facet = facets.levels.find((x) => x.level === l);
            return (
              <option key={l} value={l}>
                {t(`teaching.levels.${l}`)} ({facet?.count ?? 0})
              </option>
            );
          })}
        </select>
      </Group>

      <Group label={t('teaching.filter.language')}>
        <select
          value={filters.language}
          onChange={(e) => update({ language: e.target.value })}
          className="form-input"
        >
          <option value="">{t('teaching.filter.allLanguages')}</option>
          {facets.languages.map((l) => (
            <option key={l.code} value={l.code}>
              {l.name} ({l.count})
            </option>
          ))}
        </select>
      </Group>
    </aside>
  );
}

function Group({ label, children }) {
  return (
    <div>
      <h3 className="mb-2 text-[0.7rem] font-semibold uppercase tracking-[0.15em] text-ink-muted">
        {label}
      </h3>
      {children}
    </div>
  );
}
